import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pella/sash-framework';
import { useNearestLocation } from '../../../hooks/use-nearest-location';

const StoreInfo = ({ showHeading, showButton = true, className }) => {
	const { store, status } = useNearestLocation();
	const { address, address2, city, state, postalCode } = store;

	if (status !== 'success') return null;

	const mapAddress = `${address}${address2?.length > 0 ? '+' + address2 : ''}+${city},+${state}+${postalCode}`;
	const mapUrl = mapAddress && `https://www.google.com/maps/place/${mapAddress.replace(/\s+/g, '+')}`;

	return (
		<div className={`storeInfo ${className || ''}`}>
			{showHeading && <h3 className='mb-2 mt-0'>Your Closest Lowe&apos;s Store</h3>}

			{address && <p>{address}</p>}
			{address2?.length > 0 && <p className='m-0'>{address2}</p>}
			<p className='m-0'>
				{city && <span>{city}, </span>}
				{state && <span>{state} </span>}
				{postalCode && <span>{postalCode}</span>}
			</p>

			{showButton && (
				<Button
					color='primary-alt'
					href={mapUrl}
					size='sm'
					className='mt-4 xl:mt-6'
					wide
				>
					Get Directions
				</Button>
			)}
		</div>
	);
};

StoreInfo.propTypes = {
	showHeading: PropTypes.bool,
	showButton: PropTypes.bool,
	className: PropTypes.string,
};

export default StoreInfo;
